import { DivisionDict, addBlank } from "../default-constants";

export const LABELS = {
  APPLICATION_FILE: "申請ファイル",
  APPLICATION_SHOP_TYPE: "申請店舗種別",
  STORE_INFO_APP_FORM: "店舗情報申請書",
  DIRECT_STORE: "直接店舗",
  COMPREHENSIVE_STORE: "包括店子",
  TRADE_NAME: "（屋号）",
  FC_MALL: "（FC・モール）",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  ERROR_TITLE: "申請書エラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
  APPLICATION_CONFIRM: "\r\n・申請ファイル\r\n　　ファイル名：{0}",
  LONG_BLANK:
    "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　",
};

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION: ".xlsx",
  APPLICATION_SHOP_TYPE_CODE: "applicationShopType",
};

export const APPLICATION_SHOP_TYPE_LIST: DivisionDict[] = addBlank([
  { label: LABELS.DIRECT_STORE + LABELS.TRADE_NAME, value: "01" },
  { label: LABELS.DIRECT_STORE + LABELS.FC_MALL, value: "02" },
  { label: LABELS.COMPREHENSIVE_STORE, value: "03" },
]);
